interface Token {
  chainId: string;

  tokenSymbol: string;
  chainName?: string;
}

export const getTokenConversionMessage = ({
  from,
  to,
}: {
  from: Token;
  to: Token;
}) => {
  const requiresTokenConversion =
    from.chainId !== to.chainId || from.tokenSymbol !== to.tokenSymbol;

  if (!requiresTokenConversion) return "";

  if (from.chainId === to.chainId && from.tokenSymbol !== to.tokenSymbol) {
    return `We'll convert your ${from.tokenSymbol} to ${to.tokenSymbol}${to.chainName ? ` on ${to.chainName}` : ""}.`;
  } else if (
    from.chainId !== to.chainId &&
    from.tokenSymbol === to.tokenSymbol
  ) {
    return `We'll transfer your ${from.tokenSymbol}${from.chainName ? ` from ${from.chainName}` : ""}${to.chainName ? ` to ${to.chainName}` : ""}.`;
  } else {
    return `We'll convert your ${from.tokenSymbol}${from.chainName ? ` on ${from.chainName}` : ""} to ${to.tokenSymbol}${to.chainName ? ` on ${to.chainName}` : ""}.`;
  }
};
